/* snippet-sticky-atc-custom.js */


window.stickyAtcObserver = null;

  const showInstallments = () => {
    const elementItem = document.querySelector('.product-form__installments--item').dataset.productId;
    const elementId = `product-form__installments--${elementItem}`;
    const storageKey = 'user_geo_data';
    const hoursToCache = 24;

    console.log('showInstallments: function started');

    const el = document.getElementById(elementId);
    if (!el) {
      console.log('showInstallments: element not found');
      return;
    }

    console.log('showInstallments: element found', el);

    
    el.classList.add('hidden');
    console.log('showInstallments: element hidden');

    function showElement() {
      el.classList.remove('hidden');
      console.log('showInstallments: element shown');
    }

    function isCacheValid(timestamp) {
      const now = new Date().getTime();
      const cacheTime = hoursToCache * 60 * 60 * 1000;
      return now - timestamp < cacheTime;
    }

    const cachedData = localStorage.getItem(storageKey);

    if (cachedData) {
      console.log('showInstallments: cached data found', cachedData);
      const parsedData = JSON.parse(cachedData);
      console.log('parsedData',parsedData);
      

      if (isCacheValid(parsedData.timestamp)) {
        console.log('showInstallments: cache is valid, country:', parsedData.countryCode);
        if (parsedData.countryCode === 'US' || parsedData.countryCode === 'CA') {
          showElement();
        }
        return;
      } else {
        console.log('showInstallments: cache expired');
      }
    } else {
      console.log('showInstallments: no cached data');
    }

    console.log('showInstallments: fetching geo data');
    fetch('https://ipapi.co/json/')
      .then((response) => response.json())
      .then((data) => {
        console.log('showInstallments: geo data received', data);
        const country = data.country_code;

        const dataToSave = {
          countryCode: country,
          timestamp: new Date().getTime(),
        };

        localStorage.setItem(storageKey, JSON.stringify(dataToSave));
        console.log('showInstallments: data saved to localStorage');

        if (country === 'US' || country === 'CA') {
          showElement();
        } else {
          console.log('showInstallments: country is not US, keeping hidden');
        }
      })
      .catch((error) => {
        console.error('showInstallments: error fetching country', error);
      });
  };

  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showInstallments);
  } else {
    
    showInstallments();
  }

function stickyAtc() {
 // console.log('Sticky ATC init............');

  const containerStickyAtc = document.querySelector('.sticky-atc');
  if (!containerStickyAtc) {
   // console.log('Error: .sticky-atc not found in DOM');
    return;
  }
  const enableSlideOut = containerStickyAtc.dataset.enableSlideOut;
  const desktopPosition = containerStickyAtc.dataset.desktopPosition;
  const mobilePosition = containerStickyAtc.dataset.mobilePosition;
  const productMainInfoBlock = document.querySelector('[id^="ProductInfo-template--"]');
  const imageItem = document.querySelector('.product .product__media-wrapper .swiper-wrapper');

  function updateStickyPosition() {
    const isMobile = window.innerWidth < 750;
    const position = isMobile ? mobilePosition : desktopPosition;
    containerStickyAtc.style.top = position === 'top' ? '-200px' : 'auto';
    containerStickyAtc.style.bottom = position === 'bottom' ? '-400px' : 'auto';
  }

  updateStickyPosition();
  showInstallments();

  window.addEventListener('resize', updateStickyPosition);

  if (enableSlideOut) {
    window.addEventListener('scroll', function () {
      const isTargetElementOutOfView = productMainInfoBlock.getBoundingClientRect().top < 0;

      if (isTargetElementOutOfView) {
        containerStickyAtc.classList.add('show');
      } else {
        containerStickyAtc.classList.remove('show');
      }
    });
  } else {
    containerStickyAtc.classList.add('show');
  }





  if (!productMainInfoBlock || !imageItem) {
    console.error('Sticky ATC: Critical blocks not found in DOM');
    return;
  }

  const productFormId = containerStickyAtc
    .querySelector('.sticky-atc-button')
    ?.getAttribute('form');
  const productMainQuantityValue = productFormId
    ? Array.from(document.querySelectorAll('.quantity__input[name="quantity"][form]'))
        .find((input) => input.getAttribute('form') === productFormId)
    : null;
  const atcVariantSelect = document.querySelectorAll('.sticky-atc variant-selects select');
  const atcQuantity = document.querySelectorAll('.js-sticky-atc__quantity-select-holder select');

  const stickyPriceData = JSON.parse(containerStickyAtc.querySelector('[data-sticky-price-data]').textContent);
  let currentStickyVariant = stickyPriceData.variant;
  const priceLocale = new Intl.Locale(stickyPriceData.locale, { region: stickyPriceData.country }).toString();
  const stickyMoneyFormatter = new Intl.NumberFormat(priceLocale, {
    style: 'currency',
    currency: stickyPriceData.currency,
  });
  const submittedForm = () => document.getElementById(productFormId);
  const submittedQuantityInput = () => submittedForm()?.elements.namedItem('quantity');
  const stickyPrices = containerStickyAtc.querySelectorAll('.sticky-atc-price .price');
  const setPriceText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };
  const setPriceClass = (element, name, enabled) => {
    if (element.classList.contains(name) !== enabled) element.classList.toggle(name, enabled);
  };

  const updateStickyTotals = () => {
    const submittedVariantId = submittedForm()?.elements.namedItem('id')?.value;
    const quantityField = submittedQuantityInput();
    const quantity = quantityField ? Number(quantityField.value) : 1;
    const valid = Boolean(currentStickyVariant?.available)
      && String(currentStickyVariant.id) === String(submittedVariantId)
      && Number.isFinite(currentStickyVariant.price)
      && Number.isInteger(quantity) && quantity > 0;

    stickyPrices.forEach(priceElement => {
      setPriceClass(priceElement, 'hidden', !valid);
      if (!valid) return;

      const onSale = Number.isFinite(currentStickyVariant.compare_at_price)
        && currentStickyVariant.compare_at_price > currentStickyVariant.price;
      const sellingTotal = stickyMoneyFormatter.format(currentStickyVariant.price * quantity / 100);
      const compareTotal = onSale
        ? stickyMoneyFormatter.format(currentStickyVariant.compare_at_price * quantity / 100)
        : '';
      setPriceText(priceElement.querySelector('.price__regular .price-item--regular:not(s)'), sellingTotal);
      setPriceText(priceElement.querySelector('.price__sale .price-item--sale'), sellingTotal);
      setPriceText(priceElement.querySelector('.price__sale s.price-item--regular'), compareTotal);
      setPriceClass(priceElement, 'price--on-sale', onSale);
    });
  };

  // Reinitialization must not stack quantity listeners or variant subscriptions.
  containerStickyAtc.cleanupStickyTotals?.();
  const onMainQuantityChange = (event) => {
    if (event.target === submittedQuantityInput()) updateStickyTotals();
  };
  document.addEventListener('input', onMainQuantityChange);
  document.addEventListener('change', onMainQuantityChange);
  const unsubscribeStickyVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (String(data.sectionId) !== containerStickyAtc.dataset.sectionId) return;
    currentStickyVariant = data.variant;
    updateStickyTotals();
  });
  containerStickyAtc.cleanupStickyTotals = () => {
    document.removeEventListener('input', onMainQuantityChange);
    document.removeEventListener('change', onMainQuantityChange);
    unsubscribeStickyVariant();
  };

  const updateAtcContent = () => {

    const mainSelects = productMainInfoBlock.querySelectorAll('.product__info-wrapper variant-selects .product-form__input select');

    const selectedOptions = Array.from(mainSelects).reduce((acc, select) => {
      const optionNameMatch = select.name.match(/options\[(.*?)\]/);
      if (optionNameMatch && optionNameMatch[1]) {
        acc[optionNameMatch[1]] = select.value.trim();
      }
      return acc;
    }, {});

    const data = {
      selectedOptions: selectedOptions,
      imageItem: imageItem
    };

    const imgStickyAtc = document.querySelector('.sticky-atc .sticky-atc-image img');
    updateStickyTotals();


    atcVariantSelect.forEach(item => {
      const optionNameMatch = item.name.match(/options\[(.*?)\]/);
      if (optionNameMatch && optionNameMatch[1]) {
        const optionName = optionNameMatch[1];
        if (data.selectedOptions[optionName]) {
          item.value = data.selectedOptions[optionName];
        }
      }
    });


    let activeImageFound = false;
    Array.from(data.imageItem.children).forEach(item => {
      if (item.classList.contains('swiper-slide-active')) {
        const img = item.querySelector('img');
        if (img) {
          imgStickyAtc.src = img.src;
          activeImageFound = true;
        }
      }
    });

    if (!activeImageFound && data.imageItem.children.length > 0) {
      const firstImg = data.imageItem.children[0].querySelector('img');
      if (firstImg) imgStickyAtc.src = firstImg.src;
    }
  };


  const updateQuantityContent = () => {


    atcVariantSelect.forEach(item => {

      item.onchange = (event) => {
        

        const scrollPosition = window.scrollY;
        const mainSelects = productMainInfoBlock.querySelectorAll('.product-form__input select');        

        mainSelects.forEach(select => select.setAttribute('tabindex', '-1'));

        const optionNameMatch = item.name.match(/options\[(.*?)\]/);
        if (optionNameMatch && optionNameMatch[1]) {
          const optionName = optionNameMatch[1];
          const mainSelect = productMainInfoBlock.querySelector(`select[name="options[${optionName}]"]`);

          if (mainSelect) {
            mainSelect.value = item.value;
            mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        atcQuantity.forEach(q => q.value = 1);

        setTimeout(() => {
          mainSelects.forEach(select => select.removeAttribute('tabindex'));
          window.scrollTo(0, scrollPosition);
        }, 1000);
      };
    });

    atcQuantity.forEach(item => {
      item.onchange = () => {
        if (productMainQuantityValue) productMainQuantityValue.value = item.value;
        updateStickyTotals();
      };
    });
  };

  const render = () => {

    updateQuantityContent();

    updateAtcContent();


    if (window.stickyAtcObserver) {
      window.stickyAtcObserver.disconnect();
    }


    window.stickyAtcObserver = new MutationObserver(() => updateAtcContent());

    window.stickyAtcObserver.observe(
      productMainInfoBlock,
      { childList: true, subtree: true, attributes: true }
    );


    window.stickyAtcObserver.observe(
      imageItem,
      { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }
    );
  }

  render();
}


window.initStickyAtc = stickyAtc;


stickyAtc();
